import { render } from "./MWRegistration.vue?vue&type=template&id=d85dedec"
import script from "./MWRegistration.vue?vue&type=script&lang=js"
export * from "./MWRegistration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__